<template>
  <div eagle-form-item="photo">
    <photo-selector
      :disabled="disabled || readonly"
      :photoManager="photoManager"
      :type="photoType"
      :multiple="multiple"
      :total="total"
      v-model="data"
    ></photo-selector>
  </div>
</template>

<script>
import formItemMixin from '@/components/form/mixins/formItemMixin'
export default {
  mixins: [formItemMixin],
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.data = window.eagleLodash.cloneDeep(this.storeData)
    },
  },
  computed: {
    photoType() {
      return this.formDataItem.photoType || 'default'
    },
    multiple() {
      return this.formDataItem.multiple === true
    },
    total() {
      return this.formDataItem.total || null
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        if(window.eagleLodash.isEqual(this.data, this.storeData)) return
        this.sync()
      },
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
